// Questions du quiz sur le manuel du combattant
const quizData = [
  {
    question: "1. Quelle est la portée maximale du HK416 F-S ?",
    answers: [
      { text: "3000 mètres", correct: false },
      { text: "2800 mètres", correct: false },
      { text: "3200 mètres", correct: true },
      { text: "3800 mètres", correct: false }
    ]
  },
  {
    question: "2. Quelle est la pénétration de la balle du Glock 17 Gen 5 ?",
    answers: [
      { text: "25cm de sapin à 15m", correct: false },
      { text: "25cm de sapin à 25m", correct: false },
      { text: "35cm de sapin à 20m", correct: false },
      { text: "15cm de sapin à 25m", correct: true }
    ]
  },
  {
    question: "3. Quel est le poids en ordre de combat du FN SCAR-H PR ?",
    answers: [
      { text: "7,230 Kg", correct: false },
      { text: "6,75 Kg", correct: true },
      { text: "5,35 Kg", correct: false },
      { text: "7,780 Kg", correct: false }
    ]
  },
  {
    question: "4. Quelle est la portée maximale de l'ER314 ?",
    answers: [
      { text: "12 km", correct: true },
      { text: "15 km", correct: false },
      { text: "13 km", correct: false },
      { text: "8 km", correct: false }
    ]
  },
  {
    question: "5. Quelle est la règle de montage des radios du système PR4G ?",
    answers: [
      { text: "Alimentation-Antenne-Arrêt-Accessoires", correct: false },
      { text: "Arrêt-Alimentation-Antenne-Accessoires", correct: false },
      { text: "Arrêt-Antenne-Alimentation-Accessoires", correct: true },
      { text: "Accessoires-Alimentation-Antenne-Arrêt", correct: false }
    ]
  },
  {
    question: "6. Qu'est-ce que l'Azimut ?",
    answers: [
      { text: "L'angle compris entre ma boussole et le Sud", correct: false },
      { text: "L'angle formé entre le nord magnétique et une direction donnée", correct: true },
      { text: "L'angle formé par ma boussole à 6400 millièmes", correct: false },
      { text: "La direction donnée par l'étoile polaire", correct: false }
    ]
  },
  {
    question: "7. Qu'est-ce que le Gisement ?",
    answers: [
      { text: "L'angle formé entre le nord de la carte et une direction donnée", correct: true },
      { text: "L'angle formé par mon équerre sur la carte en suivant ma boussole", correct: false },
      { text: "L'angle formé par la DMR", correct: false },
      { text: "L'angle formé par le nord géographique et une direction donnée", correct: false }
    ]
  },
  {
    question: "8. Quels sont les 3 actes élémentaires du soldat ?",
    answers: [
      { text: "S'orienter-Observer-Progresser", correct: false },
      { text: "Se protéger-Se poster-Se camoufler", correct: false },
      { text: "S'équiper-Se déplacer-Rendre compte", correct: false },
      { text: "Se déplacer-Se poster-Utiliser ses armes", correct: true }
    ]
  },
  {
    question: "9. Quelle est la procédure à effectuer sur chaque lot de mèche lente avant utilisation ?",
    answers: [
      { text: "Égaliser-Rafraîchir-Étalonner", correct: true },
      { text: "Rafraîchir-Étalonner-Égaliser", correct: false },
      { text: "Étalonner-Égaliser-Rafraîchir", correct: false },
      { text: "Rafraîchir-Étaler-Égaliser", correct: false }
    ]
  },
  {
    question: "10. Quel est le cadre d'ordre de tir pour le fusil d'assaut ?",
    answers: [
      { text: "Objectif-Distance-Feu", correct: false },
      { text: "Hausse-Consommation-Objectif-Débit-Feu", correct: false },
      { text: "Objectif-Consommation-Feu", correct: false },
      { text: "Consommation-Objectif-Feu", correct: true }
    ]
  }
];

let userAnswers = [];

function initQuiz() {
  const container = document.getElementById('quiz-questions');
  if (!container) return;
  
  container.innerHTML = '';
  userAnswers = [];
  
  quizData.forEach((q, qIndex) => {
    const questionDiv = document.createElement('div');
    questionDiv.className = 'question';
    
    const questionTitle = document.createElement('h3');
    questionTitle.textContent = q.question;
    questionDiv.appendChild(questionTitle);
    
    q.answers.forEach((answer, aIndex) => {
      const label = document.createElement('label');
      label.className = 'answer-option';
      
      const input = document.createElement('input');
      input.type = 'radio';
      input.name = `question${qIndex}`;
      input.value = aIndex;
      
      label.appendChild(input);
      label.appendChild(document.createTextNode(answer.text));
      questionDiv.appendChild(label);
    });
    
    container.appendChild(questionDiv);
  });
  
  document.getElementById('submit-quiz').style.display = 'block';
  document.getElementById('quiz-result').style.display = 'none';
  document.getElementById('restart-quiz').style.display = 'none';
}

function calculateScore() {
  let score = 0;
  userAnswers = [];
  
  quizData.forEach((q, qIndex) => {
    const selected = document.querySelector(`input[name="question${qIndex}"]:checked`);
    if (selected) {
      const answerIndex = parseInt(selected.value);
      const isCorrect = q.answers[answerIndex].correct;
      
      userAnswers.push({
        questionIndex: qIndex,
        selectedAnswer: answerIndex,
        isCorrect: isCorrect
      });
      
      if (isCorrect) {
        score++;
      }
    }
  });
  
  return score;
}

// NOUVELLE FONCTION : Afficher la correction détaillée
function showCorrection() {
  const correctionContainer = document.getElementById('correction-details');
  if (!correctionContainer) return;
  
  correctionContainer.innerHTML = '';
  
  quizData.forEach((q, qIndex) => {
    const userAnswer = userAnswers[qIndex];
    const correctAnswerIndex = q.answers.findIndex(a => a.correct);
    
    const correctionDiv = document.createElement('div');
    
    if (userAnswer && userAnswer.isCorrect) {
      correctionDiv.className = 'correct-answer';
      correctionDiv.innerHTML = `
        <strong>✅ ${q.question}</strong><br>
        <span style="color: #155724;">Votre réponse : ${q.answers[userAnswer.selectedAnswer].text}</span><br>
        <em style="color: #155724; font-size: 14px;">👍 Bravo ! C'est la bonne réponse.</em>
      `;
    } else {
      correctionDiv.className = 'incorrect-answer';
      const userAnswerText = userAnswer ? q.answers[userAnswer.selectedAnswer].text : 'Aucune réponse';
      
      correctionDiv.innerHTML = `
        <strong>❌ ${q.question}</strong><br>
        <span style="color: #856404;">Votre réponse : ${userAnswerText}</span><br>
        <span style="color: #28a745; font-weight: bold;">Bonne réponse : ${q.answers[correctAnswerIndex].text}</span>
      `;
    }
    
    correctionContainer.appendChild(correctionDiv);
  });
}

function showResult() {
  const score = calculateScore();
  const total = quizData.length;
  const percentage = Math.round((score / total) * 100);
  
  document.getElementById('score-display').textContent = `Votre score : ${score}/${total} (${percentage}%)`;
  
  let feedback = '';
  let buyButton = '';
  
  if (percentage >= 90) {
    feedback = "🎖️ Excellent ! Vous maîtrisez bien votre sujet, maintenez votre niveau avec le Carnet du Combattant.";
    buyButton = '<a href="/https://carnetducombattant.com/products/carnet-du-combattant?variant=56123572617602" style="display: inline-block; background: #28a745; color: white; padding: 15px 30px; text-decoration: none; border-radius: 5px; font-weight: bold; margin-top: 20px;">📖 Commander le Carnet du Combattant</a>';
  } else if (percentage >= 70) {
    feedback = "✅ Pas mal ! Vous avez de bonnes connaissances, complétez les avec le Carnet du Combattant.";
    buyButton = '<a href="https://carnetducombattant.com/products/carnet-du-combattant?variant=56123572617602" style="display: inline-block; background: #28a745; color: white; padding: 15px 30px; text-decoration: none; border-radius: 5px; font-weight: bold; margin-top: 20px;">📖 Compléter mes connaissances</a>';
  } else if (percentage >= 50) {
    feedback = "📚 Aïe Aïe Aïe. Pas terrible... Vous avez des bases mais certaines connaissances méritent d'être approfondies avec le Carnet du Combattant.";
    buyButton = '<a href="https://carnetducombattant.com/products/carnet-du-combattant?variant=56123572617602" style="display: inline-block; background: #ff6b6b; color: white; padding: 15px 30px; text-decoration: none; border-radius: 5px; font-weight: bold; margin-top: 20px;">📖 Approfondir mes connaissances</a>';
  } else {
    feedback = "📖 Un soldat ne peut pas se permettre d'aussi grosses lacunes ! Corrigez vos erreurs avec le Carnet du Combattant.";
    buyButton = '<a href="https://carnetducombattant.com/products/carnet-du-combattant?variant=56123572617602" style="display: inline-block; background: #dc3545; color: white; padding: 15px 30px; text-decoration: none; border-radius: 5px; font-weight: bold; margin-top: 20px;">🚨 Commander maintenant</a>';
  }
  
  document.getElementById('feedback').innerHTML = feedback + '<br>' + buyButton;
  
  // Afficher la correction détaillée
  showCorrection();
  
  document.getElementById('quiz-result').style.display = 'block';
  document.getElementById('submit-quiz').style.display = 'none';
  document.getElementById('restart-quiz').style.display = 'block';
  document.getElementById('quiz-questions').style.display = 'none';
  
  document.getElementById('quiz-result').scrollIntoView({ behavior: 'smooth', block: 'center' });
}

document.addEventListener('DOMContentLoaded', function() {
  if (document.getElementById('quiz-container')) {
    initQuiz();
    
    document.getElementById('submit-quiz').addEventListener('click', function() {
      let allAnswered = true;
      for (let i = 0; i < quizData.length; i++) {
        if (!document.querySelector(`input[name="question${i}"]:checked`)) {
          allAnswered = false;
          break;
        }
      }
      
      if (!allAnswered) {
        alert('Veuillez répondre à toutes les questions avant de soumettre le quiz.');
        return;
      }
      
      showResult();
    });
    
    document.getElementById('restart-quiz').addEventListener('click', function() {
      document.getElementById('quiz-questions').style.display = 'block';
      initQuiz();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }
});

